<template>
	<div id="page">

		<Header></Header>

		<div id="banner">
			<img class="pc-banner" :src="imgPrefix + 'static/service_banner.jpg'" />
			<img class="mobile-banner" :src="imgPrefix + 'static/mobile_service_banner.jpg'" />
		</div>

		<div id="service">
			<div class="project">
				<div class="container">
					<div class="title">服务范畴</div>
					<ul>
						<li v-for="(item, index) in this.product_categorys">
							<!-- <a :href="'product/'+item.id+'.html'"></a> -->
              <a @click="goProductAnchor('/product.html', 'floor-'+(index+1))" style="cursor: pointer;">
                <div class="img">
                  <img class="pcShow" :src="pcImgPrefix + item.s_img_url">
                  <img class="mobileShow" :src="pcImgPrefix + item.m_s_img_url">
                  <span class="mobileShow">{{ item.cname }}</span>
                  <div class="garyBg mobileShow"></div>
                </div>
              </a>
							<div class="txt">
								<div class="margin">
									<h2 class="pcShow">{{ item.sname }}</h2>
									<p class="p1">{{ item.sdname }}</p>
                  <p class="p2" v-html="item.short_desc.replace(/\s+|，/ig, '<br/>')"></p>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="quality" id="quality">
			<div class="container">
				<div class="title">高端品质</div>
				<ul>
					<li>
						<div class="img">
							<img :src="imgPrefix + 'static/service_img05.jpg'" />
						</div>
						<div class="txt">
							<div class="margin">
							<h2>丰富的经验</h2>
							<p>惠州得胜彩印有限公司创建于1984年， 30多年来始终专注于印刷领域，涉及100多个行业，服务超过100000多个客户，提供完善的设计、印制一体化定制服务，已成为国内众多知名品牌企业值得信任的供应商</p>
							</div>
						</div>
					</li>
					<li>
						<div class="img">
              <img :src="imgPrefix + 'static/service_img06.jpg'" />
						</div>
						<div class="txt">
							<div class="margin">
							<h2>先进的设备</h2>
							<p>拥有先进的德国、日本进口印刷设备，先后引进德国进口海德堡五色、四色印刷机，多台轮转机，起钉孔，胶状龙及齐全后序加工配套设备，能以快的速度完成客户的各种印刷要求</p>
							</div>
						</div>
					</li>
					<li>
						<div class="img">
              <img :src="imgPrefix + 'static/service_img07.jpg'" />
						</div>
						<div class="txt">
							<div class="margin">
							<h2>优秀的团队</h2>
							<p>拥有200多人的印刷团队，可提供集设计、制版、印刷、装订和后道加工为一体的一站式全方位服务。强大的研发设计团队，通过不断探索和钻研各种物料和结构的可塑性，结合完善的生产程序及品质管理系统，不断满足市场需求</p>
							</div>
						</div>
					</li>
					<li>
						<div class="img">
              <img :src="imgPrefix + 'static/service_img08.jpg'" />
						</div>
						<div class="txt">
							<div class="margin">
							<h2>高品质材料</h2>
							<p>采用高品质绿色环保的纸张和油墨，对色彩，平滑度还原有很大的提升，完善的管理制度，严格的质量管控，高速的生产效率， 有效保障印刷品质</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>


		<div class="mobile_service">
      <img :src="imgPrefix + 'static/mobile_service.jpg'" />
		</div>

		<div class="service_footer" id="speciality">
			<div class="container">
				<div class="title">专业服务</div>
				<ul>
					<li>
						<div class="img">
              <img :src="imgPrefix + 'static/fuwu_01.png'" />
						</div>
						<div class="txt">
							<h3>更专业</h3>
							<p>产品样式丰富<br>
								先进的技术设备<br>
								专业技术人员<br>
								始终为更好而准备<br>
								让您的产品更显高端专业
							</p>
						</div>
					</li>
					<li>
						<div class="img">
              <img :src="imgPrefix + 'static/fuwu_02.png'" />
						</div>
						<div class="txt">
							<h3>更实在</h3>
							<p>高速的生产效率<br>
								安全不伤害的材料<br>
								优质的售前售后服务<br>
								高性价有竞争力的价格<br>
								高强客户满意度
							</p>
						</div>
					</li>
					<li>
						<div class="img">
              <img :src="imgPrefix + 'static/fuwu_03.png'" />
						</div>
						<div class="txt">
							<h3>更贴心</h3>
							<p>支持量身定做<br>
								一体化全方位服务<br>
								严格品质管控认证齐全<br>
								高效准时诚信取胜<br>
								一对一服务让您放心安心
							</p>
						</div>
					</li>
				</ul>
			</div>
		</div>


		<Footer></Footer>

	</div>
</template>

<script>
	import Header from '../components/Header.vue';
	import Footer from '../components/Footer.vue';

  import {getProductCategoryList} from "../axios/api";

	export default {
    data() {
      return{
        imgPrefix: process.env.PREFIX_IMG,
        pcImgPrefix: process.env.PREFIX_IMG + 'productCategory/',
        product_categorys: [],
      }
    },
		components: {
			Header,
			Footer
		},
    watch: {
      $route() {
        this.$nextTick(() => { this.getServiceAnchor()});
      }
    },
    created(){
      this.$nextTick(() => { this.getServiceAnchor()});
    },
    mounted() {
      this.$nextTick(function () {
        window.addEventListener('scroll', this.handleScroll)
      })

      getProductCategoryList({'filter_params': {'display_state': 1}}).then(response => {
        this.product_categorys = response.data.data.list;
      });
	    $("#nav ul li:nth-child(3) a.parent").addClass("router-link-exact-active")
    },
    methods: {
      goProductAnchor(path, id) {
        localStorage.setItem("anchorId", id);
        this.$router.push({ path: path + '?' + id});
      },
      getServiceAnchor(){
        let select = localStorage.getItem("anchorId");
        let elm = document.getElementById(select);
        if (select && elm) {
          elm.scrollIntoView(true);
          localStorage.setItem('anchorId', '')
        }
      }
    }
	}
</script>

<style>
	.mobileShow{
		display: none;
	}
	.mobile-banner{
		display: none;
	}

	.project{
		min-height: 0;
		overflow: hidden;
		margin: 80px 0 90px 0;

	}

	.project .title{
		letter-spacing: 2px;
		margin-bottom: 50px;
	}

	.project ul li{
		width: 16%;
		float: left;
		text-align: center;
		margin-right: .8%;
	}

	.project ul li img{
		width: 100%;
	}

	.project ul li .img{
		position: relative;
	}

	.project ul li .garyBg{
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		background: rgba(0,0,0,.2);
	}



	.project ul li .img h2{
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		text-align: left;
		font-size: 30px;
	}

	.project ul li:last-child{
		margin-right: 0;
	}

	/* .project ul{
		max-width: 1260px;
		margin: auto;
	} */

	.project .title{
		text-align: center;
		font-size: 42px;
		color: #333333;
	}

	.project ul li .txt{
		margin-top: 22px;
	}

	.project ul li .txt h2{
		font-size: 26px;
		color: #00a0e9;
		height: 45px;
		border-bottom: 1px solid #ff6600;
		letter-spacing: 1px;
	}

	.project ul li .txt p{
		margin-bottom: 0;
	}

	.project ul li .txt .p1{
		font-size:21px;
		color: #333333;
		margin-top: 20px;
		margin-bottom: 10px;
	}

	.project ul li .txt .p2{
		font-size:14px;
		color: #999999;
		letter-spacing: 1px;
	}

	.quality{
		background: #eeeeee;
		padding: 80px 0;
	}

	.quality .title{
		text-align: center;
		font-size: 42px;
		color: #333333;
		margin-bottom: 40px;
	}

	.quality ul li{
		background: #fff;
		min-height: 0;
		overflow: hidden;
		margin-bottom: 40px;
		position: relative;
	}

	.quality ul li .txt{
		width: 43.3%;
		position: absolute;
		height: 100%;
		right: 0;

	}

	.quality ul li .txt h2{
		font-size: 36px;
		color: #00a0e9;
		letter-spacing: 1px;
		margin-bottom: 25px;
	}

	.quality ul li .txt p{
		font-size: 18px;
		color: #333333;
		margin-bottom: 0;
		line-height: 32px;
	}

	.quality ul li .img{
		width: 56.7%;
		float: left;
	}

	.quality ul li .img img{
		width: 100%;
	}

	.quality ul li:nth-child(2n) .img{
		float: right;
	}

	.quality ul li:nth-child(2n) .txt{
		left: 0;
	}

	.quality ul li:nth-child(2n) .txt h2{
		color: #ff6600;
	}

	.quality ul li .margin{
		position: absolute;
		top: 50%;
		transform: translate(0,-50%);
		margin: 0 10%;
	}

	.service_footer{
		height: 472px;
		background: url('https://img.ds-cy.com/static/service_bg.jpg') no-repeat;
		background-position: top center;
	}
	.service_footer ul li{
		width: 33.3333%;
		float: left;
	}
	.service_footer .title{
		color: #fff;
		font-size: 42px;
		text-align: center;
		padding: 50px;
		padding-bottom: 60px;
		letter-spacing: 1px;
	}
	.service_footer ul li .img{
		width: 142px;
		float: left;
		margin-right: 28px;
	}
	.service_footer ul li .img img{
		width: 100%;
	}
	.service_footer ul li h3{
		color: #fff;
		font-size: 37px;
		margin-top: 8px;
		padding-bottom: 5px;
	}
	.service_footer ul li p{
		font-size: 16px;
		color: #fff;
		line-height: 28px;
	}
	.mobile_service{
		display: none;
	}
	.mobile_service img{
		width: 100%;
	}
	@media (max-width:1199px) {
		.quality ul li .txt h2{
			font-size: 26px;
			margin-bottom: 15px;
		}
		.quality ul li .txt p{
			font-size: 16px;
			line-height: 26px;
		}
		.service_footer ul li h3{
			font-size: 22px;
			margin-top: 3px;
		}
		.service_footer ul li p{
			font-size: 14px;
			line-height: 25px;
		}
		.service_footer ul li .img{
			width: 110px;
		}
		.service_footer{
			height: 420px;
		}
		.service_footer .title{
			font-size: 33px;
		}
		.project ul li .txt h2{
			font-size: 24px;
			height: 43px;
		}
		.project ul li .txt .p1{
			font-size: 19px;
		}
		.project ul li .txt h2{
			font-size: 20px;
			height: 40px;
		}
		.project ul li .txt .p1{
			font-size: 16px;
			margin-top: 14px;
			margin-bottom: 7px;
		}
		.project ul li .txt .p2{
			font-size: 13px;
		}
		/* .project ul li{
			width: 33%;
		} */
	}

	@media (max-width:991px) {
		.quality{
			padding: 60px 0;
		}
		.project{
			margin: 60px 0 40px 0;
		}
		.project ul li{
			width: 32%;
			margin-bottom: 30px;
		}
		.project ul li .txt{
			margin-top: 15px;
		}

		.project .title{
			font-size: 26px;
			margin-bottom: 15px;
		}
		.quality .title{
			font-size: 26px;
			margin-bottom: 15px;
		}
		.quality ul li .img{
			width: 100%;
			float: inherit;
		}
		.quality ul li .margin{
			position: initial;
			-webkit-transform: translate(0,0);
			transform: translate(0,0);
			margin: 12px 2%;
		}
		.quality ul li .txt{
			position: initial;
			width: 100%;
		}
		.quality ul li .txt h2 {
		    font-size: 22px;
		    margin-bottom: 8px;
		}
		.quality ul li .txt p {
		    font-size: 15px;
		    line-height: 25px;
		}
		.quality ul li{
			padding-bottom: 10px;
			margin-bottom: 12px;
			padding: 12px;
		}
		.quality ul li:nth-child(2n) .img {
		    float: inherit;
		}
		.quality .container{
			padding-left:12px;
			padding-right: 12px;
		}
		/* .service_footer ul li{
			width: 100%;
		} */
		.service_footer ul li .img{
			width: 75px;
			margin-right: 15px;
		}
		/* .service_footer{
			display: none;
		} */
		.service_footer ul li p {
		    font-size: 12px;
		    line-height: 18px;
		}
		.service_footer ul li h3 {
		    font-size: 18px;
		    margin-top: 3px;
		    margin-bottom:2px;
		}
		.service_footer ul li{
			/* display: flex; */
		}
		.service_footer {
		    height: 350px;
		}
		.service_footer .title {
		    font-size: 30px;
		}
	}

	@media (max-width:767px) {
		.mobile_service{
			display: block;
		}
		#speciality{
			display: none;
		}
		.project ul li span{
			display: block;
			position: absolute;width: 100%;
			left: 0;
			bottom: 0;
			text-align: center;
			font-size: 18px;
			color: #fff;
			margin-bottom: 13px;
			z-index: 9;
		}
		.mobileShow{
			display: block;
		}
		.pcShow{
			display: none;
		}
		.pc-banner{
			display: none;
		}
		.mobile-banner{
			display: block;
		}

		.project ul li{
			margin-right: 0;
			width: 48%;
			margin-bottom: 20px;
		}
		.project ul li:nth-child(2n){
			float: right;
		}
		.project ul li .txt h2{
			border: none;
			font-size: 22px;
			line-height: 40px;
			height: 40px;
			margin-bottom: 0;
		}

		.project ul li .txt .p2{
			font-size: 12px;
			letter-spacing: 0;
			
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
		}
		.project ul li .txt .p1{
			font-size: 18px;
			color: #333333;
			margin-top: 0;
			margin-bottom: 3px;
		}
		.project ul li .txt{
			margin-top: 6px;
		}
		.quality{
			padding: 20px 0;
		}
		.project{
			margin-top: 30px;
			margin-bottom: 10px;
		}
		
	}
	
	@media (max-width:450px) {
		.project ul li .txt .p2 br{
			display: none;
		}
		.project ul li .txt .p1{
			font-size: 17px;
		}
	}


	@media (max-width:350px) {
		.project ul li .txt .p1{
			font-size: 14px;
		}
		.project ul li .txt .p2{
			font-size: 11px;
		}
	}
</style>




// WEBPACK FOOTER //
// src/page/service.html.vue